<template>
  <div>
    <div v-if="noAccess">
      <b-card>
        <b-card-header>
          <p class="h2 mb-2">
            <b-icon-exclamation-triangle-fill variant="danger"></b-icon-exclamation-triangle-fill
            >&nbsp;Restricted
          </p>
        </b-card-header>
        <b-card-body>Access is Restricted</b-card-body>
      </b-card>
    </div>
    <div v-else>
      <base-header class="pb-0 bg-light">
        <b-row align-v="center" class="py-4">
          <b-col cols="12" lg="6">
            <h6 class="h2 d-inline-block mb-0 text-dark">eSIM Report</h6>
          </b-col>
          <b-col cols="12" lg="6" class="text-right">
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-bread-crumb></route-bread-crumb>
            </nav>
          </b-col>
        </b-row>
      </base-header>
      <b-card class="m-3 my-5">
        <b-card-body>
          <div>
            <h4>
              eSIM Profile Report Details
              <b-dropdown id="dropdown-1" text="icon" class="m-md-2" variant="red" :disabled="isBusy">
                <template #button-content>
                  <b-icon-bar-chart-fill variant="danger"></b-icon-bar-chart-fill>
                </template>
                <b-dropdown-item @click="toggleBusy">Export to CSV</b-dropdown-item>
              </b-dropdown>
            </h4>
          </div>
          <div class="grey-sideborder">
          <b-table
                head-row-variant="primary"
                id="inventoryTable"
                class="primary-table w-auto"
                style
                sticky-header
                :items="items"
                :busy="isBusy"
                show-empty
                responsive
                striped
                hover
                outlined>
            <template #table-busy>
              <div class="text-center my-2">
                <b-button variant="primary" disabled>
                  <b-spinner small type="grow"></b-spinner>
                  Loading...
                </b-button>
              </div>
            </template>
          </b-table>
          </div>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import eSimDashboardService from "../../../common/api-services/esim-dashboard-service";
import {exportToCSV} from "../../../common/export-to-csv";
import initService from "@/common/api-services/init-service";

export default {
  components: {
    RouteBreadCrumb,
  },
  data() {
    return {
      isBusy: false,
      items: [],
    };
  },
  methods: {
    toggleBusy() {
      exportToCSV(this.items, "reports.csv");
    },
  },

  async mounted() {
    document.title = "eSIM - Profile";

    /** NOTE: The following needs to be in data:
     noAccess: true,
     isReadOnly: true,
     isEditor: false,
     isAdministrator: false,
     isPortalAdmin: false,
     */

    //The user needs to be notified that this is not accessible.
    this.noAccess =
        !initService.getUserRoles().includes("Administrator") &&
        !initService.getUserRoles().includes("ESIM_ADMIN") &&
        !initService.getUserRoles().includes("ESIM_READ") &&
        !initService.getUserRoles().includes("ESIM_EDIT");

    //set the roles [isReadOnly, isEditor, isAdministrator, isPortalAdmin]
    this.isReadOnly = initService.getUserRoles().includes("ESIM_READ");
    this.isEditor = initService.getUserRoles().includes("ESIM_EDIT");
    this.isAdministrator =
        initService.getUserRoles().includes("Administrator") || initService.getUserRoles().includes("ESIM_ADMIN");
    this.isPortalAdmin = initService.getPortalAdminRole();

    //write to console.
    console.log("PAGE:", document.title);
    console.log("isReadOnly:", this.isReadOnly);
    console.log("isEditor:", this.isEditor);
    console.log("isAdministrator:", this.isAdministrator);
    console.log("isPortalAdmin:", this.isPortalAdmin);

    //don't do anything unless the user has access
    if (!this.noAccess) {
      this.isBusy = true;
      const res = await eSimDashboardService.getProfileTypes();
      this.items = await eSimDashboardService.getProfileLists(res.data.profileTypes);
      setTimeout(() => {
        this.isBusy = false;
      }, 500);
    }
  },

};
</script>
